<mat-dialog-content>
    <p> "Important: Disabling payments during business hours can disrupt active user sessions and ongoing transactions. Payments should only be disabled outside of business hours unless prior approval has been provided by the management team.</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button style="float: right;" mat-button (click)="onOk()">Continue</button>
    <button style="float: right;" mat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
